import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Megaphone, X } from "lucide-react";

// Global PRCA "yellow flag" notice. Dismissible, and reappears whenever the notice is edited
// (dismiss is keyed to updated_at). Pass m for the dark mobile palette.
export default function AnnouncementBanner({ m = false }) {
  const [a, setA] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get("/announcement").then((r) => {
      const ann = r.data?.announcement;
      if (!ann) return;
      if (localStorage.getItem("rp_ann_dismissed") === ann.updated_at) return;
      setA(ann); setOpen(true);
    }).catch(() => {});
  }, []);

  if (!open || !a) return null;
  const close = () => { localStorage.setItem("rp_ann_dismissed", a.updated_at || "1"); setOpen(false); };
  return (
    <div data-testid="announcement-banner"
      className={`relative rounded-xl border px-4 py-3 pr-9 ${m ? "bg-[#2A2208] border-[#E6B35A]/40 text-amber-100" : "bg-[#FBF4E6] border-[#E6B35A]/60 text-[#5A4100]"}`}>
      <button onClick={close} data-testid="announcement-dismiss" aria-label="Dismiss"
        className={`absolute top-2.5 right-2.5 p-1 rounded-md ${m ? "text-amber-200/70 hover:bg-white/10" : "text-[#8A6A1F] hover:bg-black/5"}`}><X className="w-4 h-4" /></button>
      <div className="flex items-center gap-2 font-bold text-sm">
        <Megaphone className="w-4 h-4" style={{ color: "#B4801F" }} /> {a.title || "PRCA Notice"}
      </div>
      <p className="text-[13px] leading-relaxed mt-1 whitespace-pre-line">{a.body}</p>
    </div>
  );
}
